import { Navigate, useNavigate } from "react-router-dom";
import { useAdminAppMode } from "../../../hooks/useAdminAppMode";
import { useIsMobile } from "../../../hooks/useMediaQuery";
import { HubFormCard, HubScreen } from "./HubPwa";
import aa from "./adminApp.module.css";
import { Button, Field, Input } from "../../ui";
import { TRIAL_DAYS } from "../../../constants/trial";
import {
  AdminPushBlock,
  BillingDetailsCard,
  formatDateRu,
  formatRub,
} from "./staffProfileShared";
import { useOwnerProfileForm } from "./ownerProfileForm";

export default function AdminOwnerProfileSettings() {
  const navigate = useNavigate();
  const isAdminApp = useAdminAppMode();
  const isMobile = useIsMobile(768);
  const isDesktop = isAdminApp && !isMobile;
  const {
    profile,
    form,
    setForm,
    pwd,
    setPwd,
    billing,
    saving,
    pwdSaving,
    payBusy,
    saveProfile,
    savePassword,
    paySubscription,
  } = useOwnerProfileForm();

  if (isDesktop) {
    return <Navigate to="/manage/app/profile" replace />;
  }

  const settingsBody = (
    <>
      <HubFormCard title="Мои данные">
        <Field label="Имя">
          <Input
            value={form.full_name}
            onChange={(e) => setForm({ ...form, full_name: e.target.value })}
          />
        </Field>
        <Field label="Телефон">
          <Input
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />
        </Field>
        <Field label="Email">
          <Input value={profile?.email || ""} readOnly />
        </Field>
        <Button type="button" onClick={saveProfile} disabled={saving}>
          {saving ? "Сохранение…" : "Сохранить"}
        </Button>
      </HubFormCard>

      {billing ? (
        <BillingDetailsCard
          billing={billing}
          payBusy={payBusy}
          onPay={paySubscription}
          trialDays={TRIAL_DAYS}
          formatRub={formatRub}
          formatDateRu={formatDateRu}
        />
      ) : null}

      <HubFormCard title="Уведомления">
        <AdminPushBlock />
      </HubFormCard>

      <HubFormCard title="Пароль">
        <Field label="Текущий пароль">
          <Input
            type="password"
            value={pwd.current}
            onChange={(e) => setPwd({ ...pwd, current: e.target.value })}
          />
        </Field>
        <Field label="Новый пароль">
          <Input
            type="password"
            value={pwd.next}
            onChange={(e) => setPwd({ ...pwd, next: e.target.value })}
          />
        </Field>
        <Button
          type="button"
          onClick={savePassword}
          disabled={pwdSaving}
          variant="secondary"
        >
          {pwdSaving ? "…" : "Сменить пароль"}
        </Button>
      </HubFormCard>

      <button
        type="button"
        className={aa.staffProfileMenuItem}
        onClick={() => navigate("/manage/app/settings")}
      >
        <span className={aa.staffProfileMenuIcon} aria-hidden>
          ⚙️
        </span>
        <span className={aa.staffProfileMenuText}>
          <strong>Настройки клуба</strong>
          <span>Портал, брендинг, импорт данных</span>
        </span>
        <span className={aa.staffProfileMenuChevron} aria-hidden />
      </button>
    </>
  );

  return (
    <HubScreen
      title="Расширенные настройки"
      onBack={() => navigate("/manage/app/profile")}
      backLabel="Профиль"
    >
      {settingsBody}
    </HubScreen>
  );
}
